const menuItems = [
    {
        title: '안전보건교육소개',
        subItems: [
            { title: '안전보건교육이란?', link: '/safety' },
            { title: '관리감독자 정기교육', link: '/safety/management' },
            { title: '근로자 정기교육', link: '/safety/worker' },
            { title: '위험성평가 교육', link: '/safety/risk' },
        ],
    },
    {
        title: '교육신청',
        subItems: [
            { title: '집체교육(대면)', link: '/lecture?eduType=B' },
            { title: '집체교육(비대면)', link: '/lecture?eduType=C' },
            { title: '집체(영상)', link: '/lecture?eduType=D' },
            { title: '집체(혼합)', link: '/lecture?eduType=E' },
        ],
    },
    {
        title: '온라인강의',
        subItems: [
            { title: '온라인교육신청', link: '/apply/online' },
        ],
    },
    {
        title: '학습지원센터',
        subItems: [
            // { title: '공지사항', link: '/support/notice' },
            { title: 'Q&A', link: '/support/qna'},
            { title: '자료실', link: '/support/reference' },
            // { title: '1:1문의', link: '/support/inquiry', requiresLogin: true },
        ],
    },
    {
        title: '나의강의실',

        requiresAuth: true, 
        subItems: [],
      },
];

export default menuItems;
